import { AokCardViewModel } from './aok-card-view-model';

export class AokPremiumShopCardViewModel extends AokCardViewModel {
    points? : number|undefined;
}